<template>
  <div class="conatiner-fluid mt-2 p-2">
    <h2>Software Module</h2>
    <div class="btn-toolbar justify-content-between">
      <button @click="installModule" class="btn btn-primary">Modul installieren</button>
      <button @click="openAdmin" class="btn btn-secondary">Administration</button>
    </div>
    <b-table :items="list" striped hover :fields="fields" class="mt-2" :tbody-tr-class="modRowClass">
      <template v-slot:cell(status)="data">
        <span>{{ statusString(data.item.status) }}</span>
      </template>
      <template v-slot:cell(actions)="data">
        <button @click="removeModule(data)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
      </template>
    </b-table>
    <b-modal id="remmodaldlg" title="Modul LÖSCHEN" header-bg-variant="danger" @ok="deleteAccepted" @cancel="deleteCanceled">
      <p>Möchten Sie das Modul <strong>{{ remmod.name }}</strong> wirklich <b>löschen</b>?</p>
      <div class="form-inline">
        <label>Bestätigung</label>
        <input type="text" placeholder="Modulname eingeben" class="form-control" v-model="remmark"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import router from '@/router'
import conmodules from '@/modules/conmodules.js'

export default {
  name: 'ModuleOverview',
  data() {
    return {
      remmod: {},
      remmark: '',
      list: [],
      fields: [
        { label: 'ID', key: 'storage_id'},
        { label: 'Name', key:'name'},
        { label: 'Version', key: 'version' },
        { label: 'Status', key: 'status'},
        { label: 'Aktionen', key: 'actions' }
      ],
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    modRowClass(item) {
      console.log(item);
      if (item.status == 3) {
        return 'table-danger';
      }
      return '';
    },
    statusString(val) {
      switch (val) {
        case 0: return 'Neu';
        case 1: return 'Entpackt';
        case 2: return 'Fertig';
        case 3: return 'Fehler';
        default: return 'Unknown';
      }
    },
    fetchData() {
      var self = this;
      conmodules.listmodules(this,function(data) {
        self.list = data;
      })
    },
    installModule: function() {
      router.push({ name: 'ModuleUpload' , params: {mid: 'new' }});
    },
    openAdmin() {
      router.push({ name: 'ModulesAdmin' });
    },
    deleteAccepted: function() {
      console.log('remove module');
      if (this.remmark != this.remmod.name) {
        this.$bvToast.toast('Modulname als Bestätigung nicht korrekt.',{title:'Modul entfernen',variant: 'warning'});
        return;
      }

      var self = this;
      conmodules.removemodule(this,this.remmod.storage_id,function(data) {
        console.log(data);
        self.$bvToast.toast('Modul wurde entfernt.',{title:'Module löschen',variant:'success'});
        self.fetchData();
      })

      this.remmark = '';

    },
    deleteCanceled() {
      this.remmark = '';
    },
    removeModule: function(row) {
      console.log(row.item);
      this.remmod = row.item;
      this.$bvModal.show('remmodaldlg');
    }

  }
}
</script>
